/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BboCashManagementBadRequestResponse,
  BboCashManagementForbiddenResponse,
  CashBalancePayload,
  CashBalancePayloadV2,
  DeclarationALResponseV2,
  FailureResponseResponse,
  NotFoundResponse,
  Success,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Create a cash balance declaration record for an accounting location
 * @summary Add a cash declaration of an accounting location
 */
export const postCashDeclaration = (cashBalancePayload: CashBalancePayload) => {
  return customInstance<Success>({
    url: `/BboCashManagementService/v1/cash-declaration/accounting-location`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: cashBalancePayload,
  });
};

export const getPostCashDeclarationMutationOptions = <
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCashDeclaration>>,
    TError,
    { data: CashBalancePayload },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCashDeclaration>>,
  TError,
  { data: CashBalancePayload },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCashDeclaration>>,
    { data: CashBalancePayload }
  > = (props) => {
    const { data } = props ?? {};

    return postCashDeclaration(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCashDeclarationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCashDeclaration>>
>;
export type PostCashDeclarationMutationBody = CashBalancePayload;
export type PostCashDeclarationMutationError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Add a cash declaration of an accounting location
 */
export const usePostCashDeclaration = <
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCashDeclaration>>,
    TError,
    { data: CashBalancePayload },
    TContext
  >;
}) => {
  const mutationOptions = getPostCashDeclarationMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Create a cash balance declaration record for an accounting location and save progressive state as well
 * @summary Add a cash declaration of an accounting location and save progressive state as well
 */
export const postCashDeclarationV2 = (cashBalancePayloadV2: CashBalancePayloadV2) => {
  return customInstance<DeclarationALResponseV2>({
    url: `/BboCashManagementService/v2/cash-declaration/accounting-location`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: cashBalancePayloadV2,
  });
};

export const getPostCashDeclarationV2MutationOptions = <
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCashDeclarationV2>>,
    TError,
    { data: CashBalancePayloadV2 },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCashDeclarationV2>>,
  TError,
  { data: CashBalancePayloadV2 },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCashDeclarationV2>>,
    { data: CashBalancePayloadV2 }
  > = (props) => {
    const { data } = props ?? {};

    return postCashDeclarationV2(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCashDeclarationV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof postCashDeclarationV2>>
>;
export type PostCashDeclarationV2MutationBody = CashBalancePayloadV2;
export type PostCashDeclarationV2MutationError = ErrorType<
  | BboCashManagementBadRequestResponse
  | UnauthorizedResponse
  | BboCashManagementForbiddenResponse
  | NotFoundResponse
  | FailureResponseResponse
>;

/**
 * @summary Add a cash declaration of an accounting location and save progressive state as well
 */
export const usePostCashDeclarationV2 = <
  TError = ErrorType<
    | BboCashManagementBadRequestResponse
    | UnauthorizedResponse
    | BboCashManagementForbiddenResponse
    | NotFoundResponse
    | FailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCashDeclarationV2>>,
    TError,
    { data: CashBalancePayloadV2 },
    TContext
  >;
}) => {
  const mutationOptions = getPostCashDeclarationV2MutationOptions(options);

  return useMutation(mutationOptions);
};
